import {h, KeepAlive} from 'vue'
import {RouterView} from 'vue-router'

// C2CRoutes
export const C2CRoutes = [
  {
    path: '/c2c',
    alias: ['/c'],
    name: 'C2C',
    component: {
      render () {
        return h(RouterView, null, {
          default: ({Component, route}) => h(KeepAlive, null, {
            default: () => h(Component, {
              key: route.fullPath,
            }),
          }),
        })
      },
    },
    children: [
      {
        path: ':uuid',
        component: RouterView,
        children: [
          {
            path: '',
            name: 'C2CDetail',
            component: RouterView,
            children: [

            ],
          },
          {
            path: 'report',
            component: RouterView,
            children: [
              // report mileage
              {
                path: 'mileage',
                name: 'C2CReportMileage',
                component: () => import('@pages/c2c-report-mileage/index.vue'),
              },
              // report vehicle & accessory delivery list
              {
                path: 'vehicle-accessory-delivery',
                name: 'C2CReportVehicleAccessoryDelivery',
                component: () => import('@pages/c2c-report-vehicle-accessory-delivery/index.vue'),
                meta: {
                  layout: 'plain',
                },
              },
              // report paperwork (手续材料)
              {
                path: 'paperwork',
                name: 'C2CReportPaperwork',
                component: () => import('@pages/c2c-report-paperwork/index.vue'),
                meta: {
                  layout: 'plain',
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
